var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IllustrationBath(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 48 48", "data-testid": "illustration-bath" }, props),
        React.createElement("path", { strokeLinejoin: "round", strokeWidth: "2", d: "M34 42H18A12 12 0 016 30v-4h36v8a8 8 0 01-8 8zM34 26V10a6 6 0 00-6-6v0a6 6 0 00-6 6v2" }),
        React.createElement("path", { className: "fill", d: "M22 10a6 6 0 00-6 6h12a6 6 0 00-6-6z" })));
}
export default IllustrationBath;
